// eventBus.js
const listeners = {};

export const eventBus = {
  subscribe: (event, callback) => {
    if (!listeners[event]) listeners[event] = [];
    listeners[event].push(callback);
  },
  publish: (event, data) => {
    if (!listeners[event]) return;
    listeners[event].forEach(callback => callback(data));
  },
};
